import React, { useState } from 'react';
import { FAQ } from '../../constants/faq';

const FAQSection: React.FC = () => {
    const [open, setOpen] = useState<number | null>(0);

    return (
        <section
            id="faq"
            className="relative z-[1] scroll-mt-24 border-t border-dark-gunmetal px-5 py-[clamp(64px,9vw,120px)]"
        >
            <div className="mx-auto grid max-w-[1180px] items-start gap-[clamp(24px,4vw,64px)] lg:grid-cols-2">
                {/* sticky heading column */}
                <div className="min-w-0 lg:sticky lg:top-[104px]">
                    <span className="text-[10px] font-medium uppercase tracking-[0.16em] text-success">
                        FAQ
                    </span>
                    <h2 className="mt-3.5 text-[clamp(28px,3.8vw,48px)] font-extrabold leading-[1.04] tracking-[-0.035em] text-white">
                        Questions? We have answers
                    </h2>
                    <p className="mt-4 max-w-[32ch] text-[16px] leading-[1.6] text-dark-textSecondary">
                        Straightforward details about how Fork works today.
                    </p>
                </div>

                {/* accordion */}
                <div className="grid min-w-0 border-b border-dark-gunmetal">
                    {FAQ.map((item, i) => {
                        const isOpen = open === i;
                        return (
                            <div key={item.question} className="border-t border-dark-gunmetal">
                                <h3>
                                    <button
                                        onClick={() => setOpen(isOpen ? null : i)}
                                        aria-expanded={isOpen}
                                        className="flex w-full cursor-pointer items-center justify-between gap-5 px-1 py-6 text-left"
                                    >
                                        <span
                                            className="text-[17px] font-semibold leading-[1.4] transition-colors duration-300"
                                            style={{ color: isOpen ? '#FCFFFF' : '#BEC3C6' }}
                                        >
                                            {item.question}
                                        </span>
                                        <span
                                            className="inline-flex shrink-0 transition-transform duration-300"
                                            style={{
                                                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                            }}
                                        >
                                            <svg
                                                width="18"
                                                height="18"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#8F9698"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                aria-hidden="true"
                                            >
                                                <path d="m6 9 6 6 6-6" />
                                            </svg>
                                        </span>
                                    </button>
                                </h3>

                                {/* grid-rows collapse, as in v1 */}
                                <div
                                    className="grid transition-[grid-template-rows] duration-[380ms] ease-out"
                                    style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                                >
                                    <div className="min-h-0 overflow-hidden">
                                        <p className="max-w-[62ch] pb-[26px] pl-1 pr-10 text-[16px] leading-[1.65] text-dark-textSecondary">
                                            {item.answer}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
